import React from 'react';

function Footer() {
    return (
        <footer className="page-footer bg-light d-flex align-items-center">
            <div className="container d-flex align-items-center pt-3">
                <p className="text-center w-100">&copy; 2019 &mdash; Peter Meltzer </p>
            </div>
        </footer>

    )
}

export default Footer;